import { format, isValid, parseISO, startOfMonth } from 'date-fns';
import { IncomeSources, Title } from 'reducers/types';
export const MONEVO_DATE_FORMAT = 'yyyy-MM-dd';
/**
 * Monevo wants the day of the month gone, so every date answer lands on the
 * 1st. Takes what a picker hands back and what the backend holds, which may
 * be a full ISO timestamp. A string keeps its own year and month: parsing a
 * UTC midnight would land on the previous month west of UTC.
 */
export const toStoredMonth = (value) => {
    if (typeof value === 'string') {
        const match = /^(\d{4})-(\d{2})/.exec(value);
        if (!match || !isValid(parseISO(value)))
            return undefined;
        return `${match[1]}-${match[2]}-01`;
    }
    if (!value || !isValid(value))
        return undefined;
    return format(startOfMonth(value), MONEVO_DATE_FORMAT);
};
const LOAN_PERIOD = [
    // { value: 6, label: '6 months', gradientKey: 'darkPurple' },
    { value: 12, label: '1 year', gradientKey: 'skyBlue' },
    { value: 24, label: '2 years', gradientKey: 'lightPink' },
    { value: 36, label: '3 years', gradientKey: 'apricot' },
    { value: 48, label: '4 years', gradientKey: 'ultimate' },
    { value: 60, label: '5+ years', gradientKey: 'orange' },
];
const LOAN_REASON = [
    { value: 3, label: 'Car purchase', emoji: '🚗' },
    { value: 7, label: 'Debt consolidation', emoji: '💳' },
    { value: 8, label: 'Holiday', emoji: '🏖' },
    { value: 9, label: 'Home improvements', emoji: '🏡' },
    { value: 10, label: 'Medical bill', emoji: '👨‍⚕️' },
    { value: 18, label: 'Other', emoji: '💸' },
];
export const loanTypeReasonValue = {
    LOAN: 0,
    DEBT: 7,
    CAR_FINANCE: 3,
    CREDIT_CARD: 29,
    HOME_IMPROVEMENTS: 9,
};
export const TITLES = [
    { value: Title.Mr, label: 'Mr' },
    { value: Title.Mrs, label: 'Mrs' },
    { value: Title.Miss, label: 'Miss' },
    { value: Title.Ms, label: 'Ms' },
    { value: Title.Dr, label: 'Dr' },
    { value: Title.Other, label: 'Other' },
];
const MARITAL_STATUS = [
    { value: 'MARRIED', label: 'Married', emoji: '💍' },
    { value: 'PARTNER', label: 'Partner', emoji: '👫' },
    { value: 'SINGLE', label: 'Single', emoji: '🚶‍♂️' },
    { value: 'CO_HABITING', label: 'Co-habiting', emoji: '🏡' },
    { value: 'SEPARATED', label: 'Separated', emoji: '🥶' },
    { value: 'DIVORCED', label: 'Divorced', emoji: '🍾' },
    { value: 'CIVIL_UNION', label: 'Civil union', emoji: '👭' },
    { value: 'WIDOWED', label: 'Widowed', emoji: '💐' },
];
const DEPENDANTS = [0, 1, 2, 3, 4, 5];
const RESIDENT_TYPE = [
    { value: 'HOMEOWNER_NO_MORTGAGE', label: 'Home owner - with no mortgage' },
    { value: 'HOMEOWNER_WITH_MORTGAGE', label: 'Home owner - with mortgage' },
    { value: 'RENTING', label: 'Rent' },
    { value: 'LIVING_WITH_FAMILY', label: 'Living with family' },
    { value: 'LIVING_WITH_PARENTS', label: 'Living with parents' },
    { value: 'JOINT_OWNER', label: 'Joint owner' },
    { value: 'TENANT_UNFURNISHED', label: 'Tenant-unfurnished' },
    { value: 'TENANT_FURNISHED', label: 'Tenant-furnished' },
    { value: 'COUNCIL_TENANT', label: 'Council tenant' },
    { value: 'OTHER', label: 'Other' },
];
const EMPLOYMENT_STATUS = [
    {
        value: '1',
        label: 'Full-time employed',
        incomeSource: IncomeSources.FULL_TIME_EMPLOYED,
    },
    {
        value: '2',
        label: 'Part-time employed',
        incomeSource: IncomeSources.PART_TIME_EMPLOYED,
    },
    {
        value: '3',
        label: 'Self-employed',
        incomeSource: IncomeSources.SELF_EMPLOYED,
    },
    {
        value: '4',
        label: 'Temporarily employed',
        incomeSource: IncomeSources.TEMPORARILY_EMPLOYED,
    },
    { value: '5', label: 'Student', incomeSource: IncomeSources.STUDENT },
    { value: '6', label: 'Pension', incomeSource: IncomeSources.PENSION },
    { value: '7', label: 'Disability', incomeSource: IncomeSources.DISABILITY },
    { value: '8', label: 'Unemployed', incomeSource: IncomeSources.UNEMPLOYED },
    { value: '9', label: 'Homemaker', incomeSource: IncomeSources.HOMEMAKER },
];
/**
 * Statuses that have an employer behind them, so we ask when the job started.
 * The rest have no start date to give.
 */
const EMPLOYED_STATUS_VALUES = ['1', '2', '4'];
export var EmploymentIndustry;
(function (EmploymentIndustry) {
    EmploymentIndustry["ACCOUNTANCY"] = "ACCOUNTANCY";
    EmploymentIndustry["MEDIA_AND_ADVERTISING"] = "MEDIA_AND_ADVERTISING";
    EmploymentIndustry["BUSINESS_CONSULTANCY"] = "BUSINESS_CONSULTANCY";
    EmploymentIndustry["CALL_CENTRE_OPERATIONS"] = "CALL_CENTRE_OPERATIONS";
    EmploymentIndustry["CLEANING_SERVICES"] = "CLEANING_SERVICES";
    EmploymentIndustry["COMPUTER_SERVICES"] = "COMPUTER_SERVICES";
    EmploymentIndustry["CONSTRUCTION"] = "CONSTRUCTION";
    EmploymentIndustry["EDUCATION"] = "EDUCATION";
    EmploymentIndustry["UTILITIES"] = "UTILITIES";
    EmploymentIndustry["FINANCE"] = "FINANCE";
    EmploymentIndustry["HEALTH"] = "HEALTH";
    EmploymentIndustry["HOTELS_AND_RESTAURANTS"] = "HOTELS_AND_RESTAURANTS";
    EmploymentIndustry["INSURANCE"] = "INSURANCE";
    EmploymentIndustry["LEGAL_SERVICES"] = "LEGAL_SERVICES";
    EmploymentIndustry["LEISURE_AND_CULTURE"] = "LEISURE_AND_CULTURE";
    EmploymentIndustry["MANUFACTURING"] = "MANUFACTURING";
    EmploymentIndustry["MILITARY"] = "MILITARY";
    EmploymentIndustry["MINING_AND_QUARRYING"] = "MINING_AND_QUARRYING";
    EmploymentIndustry["PUBLIC_ADMINISTRATION"] = "PUBLIC_ADMINISTRATION";
    EmploymentIndustry["PUBLISHING"] = "PUBLISHING";
    EmploymentIndustry["REAL_ESTATE_AND_PROPERTY"] = "REAL_ESTATE_AND_PROPERTY";
    EmploymentIndustry["RESEARCH_AND_DEVELOPMENT"] = "RESEARCH_AND_DEVELOPMENT";
    EmploymentIndustry["RETAIL"] = "RETAIL";
    EmploymentIndustry["TELECOMS_AND_INTERNET"] = "TELECOMS_AND_INTERNET";
    EmploymentIndustry["TRANSPORTATION"] = "TRANSPORTATION";
    EmploymentIndustry["OTHER"] = "OTHER";
})(EmploymentIndustry || (EmploymentIndustry = {}));
const US_STATES = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsilvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
];
export const employmentStatusMap = {
    Employed: 'EMPLOYED',
    'Self-employed': 'SELF_EMPLOYED',
    Unemployed: 'UNEMPLOYED',
    Student: 'STUDENT',
    Retired: 'RETIRED',
};
export const employmentStatuses = Object.keys(employmentStatusMap);
export const fundingSourceMap = {
    'Employment Income': 'EMPLOYMENT_INCOME',
    Investments: 'INVESTMENTS',
    Inheritance: 'INHERITANCE',
    'Business Income': 'BUSINESS_INCOME',
    Savings: 'SAVINGS',
    Family: 'FAMILY',
};
export const fundingSources = Object.keys(fundingSourceMap);
export { MARITAL_STATUS, DEPENDANTS, RESIDENT_TYPE, EMPLOYMENT_STATUS, EMPLOYED_STATUS_VALUES, LOAN_REASON, LOAN_PERIOD, US_STATES, };
